function Header(): JSX.Element {
  return (
    <header className="App-header">
      <div className="App-header-content">
        <div className="App-header-top">
          <div className="App-logo-block">
            <span className="App-logo-text">AskRegulations</span>
          </div>
          <div className="App-header-separator"></div>
          <div className="App-title-section">
            <div className="App-title-line-bold">TRANSACTION</div>
            <div className="App-title-line">MONITORING</div>
          </div>
        </div>
        <div className="App-privacy-section">
          <div className="App-privacy-content">
            <p className="App-privacy-text">
              Our platform is privacy-by-design - we never see, touch or transmit your data.
            </p>
            <p className="App-privacy-text">
              All files are processed locally in <span className="em">your</span> browser, ensuring full data control.
            </p>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;

